import { setTimeoutPromise } from './setTimeoutPromise';

export default async function retry(fetch, url, fetchOptions, retryOptions) {
  const defaultConfiguration = {
    retries: 15,
    retryDelay: 2000,
    retryPredicate: undefined
  };
  const { retries, retryDelay, retryPredicate } = Object.assign({}, defaultConfiguration, retryOptions);

  const retry = async (retryCounter) => {
    const response = await fetch(url, fetchOptions);
    let shouldRetry;
    if (retryPredicate && typeof retryPredicate === 'function') {
      shouldRetry = await retryPredicate(response);
    } else {
      shouldRetry = response.status === 404;
    }

    if (shouldRetry && retryCounter > 0) {
      await setTimeoutPromise(retryDelay);
      return await retry(retryCounter - 1);
    } else if (shouldRetry && retryCounter === 0) {
      response.retryTimeout = true;
      return response;
    } else {
      return response;
    }
  };

  return await retry(retries);
};
